import { ApplicationState } from '../../../../../core/models/application-state/application-state';
import { ApplicantTypeCodes } from '../../../direct-entry/applicant-info/constants/applicant-type-codes';

/**
 * Constructs the licensee name from the application state.
 * Returns the full name for individuals, or the entity name for organizations.
 *
 * @param applicationState The application state containing licensee information.
 * @returns The constructed licensee name, or null if applicant type code is not available.
 */
export function constructLicenseeName(
    applicationState: ApplicationState | null,
): string | null | undefined {
    const {
        applicantTypeCode,
        licenseeFirstName,
        licenseeLastName,
        licenseeEntityName,
    } = applicationState || {};

    if (!applicantTypeCode) {
        return null;
    }

    if (applicantTypeCode === ApplicantTypeCodes.individual) {
        return [licenseeFirstName, licenseeLastName].filter(Boolean).join(' ');
    }
    return licenseeEntityName;
}
